/* eslint-disable import/no-unresolved */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { RenderForGlobalExchange } from 'components/render/RenderByExchangeType';
import { ASSET_SYMBOL, IS_INDIAN_EXCHANGE } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { getBalanceBySymbol, noop, percentageForIMAndMM, round } from 'helpers';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import subscribe from 'HOC/subscribe';
import {
  balanceBySymbolSelector,
  portfolioMarginSelector,
  selectedProductSelector,
  userMarginModeSelector,
} from 'selectors';
import { useAppSelector } from 'storeHooks';

import styles from './index.module.scss';
import IMAndMMBarComponent from './marginBarsComponent';

export const PortfolioMargin = subscribe(({ openPopup }) => {
  const { t } = useTranslation(['common', 'portfolioMargin']);

  const portfolioMarginData = portfolioMarginSelector();
  const allBalances = useSelector(balanceBySymbolSelector);

  const { mm_wo_ucf, mm_w_ucf, im_w_ucf, im_wo_ucf, positions_upl } =
    portfolioMarginData?.aggregate || {};

  // USDT is hard coded, as we always check for USDT balance in this portfolio
  const { balance } = getBalanceBySymbol(ASSET_SYMBOL, allBalances) || {};
  const maintenanceMarginWithoutUcf = round(Number(mm_wo_ucf || 0), 2);
  const maintenanceMarginWithUcf = round(Number(mm_w_ucf || 0), 2);
  const initialMarginWithoutUcf = round(Number(im_wo_ucf || 0), 2);
  const initialMarginWithUcf = round(Number(im_w_ucf || 0), 2);

  const imPercentage = percentageForIMAndMM(
    initialMarginWithoutUcf,
    balance,
    positions_upl
  );
  const mmPercentage = percentageForIMAndMM(
    maintenanceMarginWithoutUcf,
    balance,
    positions_upl
  );

  const onDetailsClick = () => {
    trackMixpanelEvent('Portfolio Details Checked', {
      source: 'Trade Page',
    });
  };

  const selectedProduct = useAppSelector(state => selectedProductSelector(state));

  const marginMode = useAppSelector(userMarginModeSelector);

  const handlePortfolioEvent = () => {
    const { symbol, contract_type } = selectedProduct;
    trackMixpanelEvent(MIXPANEL_EVENT_NAMES.ORDER_PLACEMENT.MARGIN_BUTTON_CLICK, {
      source: 'Single Order',
      current_margin_mode: marginMode,
      product_type: contract_type,
      product_name: symbol,
    });
  };

  const handlePortfolioMarginClick = () => {
    if (IS_INDIAN_EXCHANGE) return;
    handlePortfolioEvent();
    openPopup(true);
  };

  return (
    (<div
      className={`${styles['portfolio-margin']} d-flex align-items-center ${
        !IS_INDIAN_EXCHANGE ? 'justify-content-between' : 'justify-content-end'
      }`}
      data-palette="PortfolioMargin">
      <RenderForGlobalExchange>
        <div
          data-testid="openPFPopup"
          className={cx(styles.head, 'd-flex align-center', {
            [styles.noOutlineOnHover]: IS_INDIAN_EXCHANGE,
          })}
          onClick={handlePortfolioMarginClick}
          onKeyDown={noop}
          role="button"
          tabIndex={0}
        >
          {t('portfolioMargin:portfolio')}
          {/* <AngleDown
          className={`${styles['chevron-down']} ${
            showModal ? styles.rotate : ''
          } d-md-none`}
        /> */}
        </div>
      </RenderForGlobalExchange>
      <div className={`d-flex align-items-center ${styles.details}`}>
        <IMAndMMBarComponent
          initialMargin={initialMarginWithUcf || 0}
          maintenanceMargin={maintenanceMarginWithUcf || 0}
          imPercentage={imPercentage}
          mmPercentage={mmPercentage}
          showDetailsLink
          redirectionLink={routes.portfolio}
          handleLinkClick={onDetailsClick}
        />
      </div>
    </div>)
  );
});
